<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPin_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M9.435.525a.7.7 0 0 1 .99 0l5.05 5.05a.7.7 0 1 1-.99.99l-1.134-1.134-2.938 3.905q.161.516.207 1.044c.106 1.22-.277 2.348-1.064 3.135l-3.04-3.04L4.04 12.95a.7.7 0 0 1-.99-.99l2.475-2.475-3.04-3.04C3.272 5.656 4.4 5.273 5.62 5.38c.35.03.701.1 1.044.208L10.57 2.65 9.435 1.515a.7.7 0 0 1 0-.99"
        clip-rule="evenodd"
    />
</svg>
